import { useCallback, useEffect, useMemo } from "react";
import { useEnvironment } from "@aviv-unified-frontend/runtime/environment";
import type { ApplicationLikeId } from "@aviv-unified-frontend/internal";

import { useOverlayOrchestrator } from "../../createOverlayOrchestratorContext";
import { useShouldInitOverlay } from "../../useShouldInitOverlay";

import { KEY } from "./constants";

const DISABLED_APPS = new Set<ApplicationLikeId>([
  "app_cads_mobileDownloadLandingPage",
]);

const isDisabledApp = (id: ApplicationLikeId | null | undefined) => {
  return id ? DISABLED_APPS.has(id) : false;
};

export const useGoogleOneTap = () => {
  const {
    application: { id },
  } = useEnvironment();

  const shouldInitOverlay = useShouldInitOverlay(KEY);
  const { state, dispatch } = useOverlayOrchestrator();

  const onDismiss = useCallback(
    () => dispatch({ type: "COMPLETE", payload: KEY }),
    [dispatch],
  );

  useEffect(() => {
    if (isDisabledApp(id)) {
      dispatch({ type: "DISABLE", payload: KEY });
    }
  }, [id, dispatch]);

  const shouldInit = useMemo(
    () => shouldInitOverlay && !isDisabledApp(id) && state[KEY] !== "disabled",
    [shouldInitOverlay, id, state],
  );

  return useMemo(
    () => ({
      shouldInit,
      onDismiss,
    }),
    [shouldInit, onDismiss],
  );
};
